import * as Yup from "yup";

export const RequestCodeValidation = (t, countryCode) => {
  return Yup.object({
    loginMethod: Yup.string().oneOf(["email", "phone_number"]).required(),
    email: Yup.string().when("loginMethod", (loginMethod, schema) => {
      return loginMethod[0] === "email"
        ? schema
            .required(t("auth.email.required"))
            .email(t("auth.email.validMessage"))
        : schema.notRequired();
    }),
    phone_number: Yup.string().when("loginMethod", (loginMethod, schema) => {
      return loginMethod[0] === "phone_number"
        ? schema
            .required(t("auth.phoneNumber.validMessage"))
            .matches(
              countryCode === "TR" ? /^\(\d{3}\)\s\d{3}\s\d{4}$/ : /^\d{13}$/,
              t("auth.phoneNumber.validMessage")
            )
        : schema.notRequired();
    }),
  });
};
